import {
  CmsBackedLandingPage,
  LANDING_PAGE_CACHE_TIME,
} from "@kunduz/feature-landing-pages";
import { serverSideTranslations } from "../common/utility/serverSideTranslations";
import { getCmsApiClientFunctions } from "@kunduz/data-access-cms-api";
import { type GetStaticPropsContext } from "next";

export default CmsBackedLandingPage;

export const getStaticProps = async ({
  params,
  locale,
}: GetStaticPropsContext) => {
  const functions = getCmsApiClientFunctions();
  const pathNames = {
    en: "",
    "en-US": "",
    tr: "/tr",
    "tr-TR": "/tr",
    "en-AE": "/en-ae",
    "en-EG": "/en-eg",
  };

  const slug = (params.landingSlug as string[]).join("/");

  try {
    let response;

    response = await functions.getContentTypeBySlug(
      `${pathNames[locale]}/${slug}/`,
    );

    if (
      response &&
      response.content_type === "landing-page" &&
      response.content.root.props.live
    ) {
      return {
        props: {
          lang: response.language,
          contentType: response,
          ...(await serverSideTranslations(response.language, [
            "kunduzcom_common",
          ])),
          by: "puck",
        },
        revalidate: LANDING_PAGE_CACHE_TIME,
      };
    }

    response = await functions.getContentType(`${pathNames[locale]}/${slug}/`);

    if (!response || response.content_type != "landing-page") {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        lang: response.language,
        meta: response,
        ...(await serverSideTranslations(response.language, [
          "kunduzcom_common",
        ])),
        by: "cms",
      },
      revalidate: LANDING_PAGE_CACHE_TIME,
    };
  } catch (error) {
    throw new Error(
      `Failed to fetch page, error detail: ${JSON.stringify(error)}`,
    );
  }
};

export const getStaticPaths = async () => {
  return { paths: [], fallback: "blocking" };
};
